import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  decodeToken,
  isTokenAuthenticated,
  loadTokenFromStorage,
} from 'utils/token';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ location }) => {
    const token = loadTokenFromStorage();
    if (isTokenAuthenticated(decodeToken(token))) {
      throw redirect({
        to: '/products',
      });
    } else {
      throw redirect({
        to: '/auth/login',
      });
    }
  },
});
